import React, { useState, useContext } from "react";
import { v4 as uuidv4 } from 'uuid';
import Slider from "r-range-slider";
import './QuestionSlider.css'

const QuestionSlider = ({ options, callback, currentAnswer }) => {
  const [state, setState] = useState({value: null, valueChanged: false, foobar: true});
  const [box, setBox] = useState({triangle: false, percentagebox: false});
  const percbox = box.percentagebox;
  const tri = box.triangle;
  const percentagebox = document.querySelector('.r-range-slider-point.active');

  if(percentagebox) {
    if(!percbox) {
      setBox({...box, percentagebox: true});
    }
  } else {
    if(percbox) {
      setBox({...box, percentagebox: false});
    }
  }

  const min = parseInt(options.min);
  const max = parseInt(options.max);
  const min_label = options.min_label;
  const max_label = options.max_label;
  const marks = {};

  for (var step = min; step <= max; step++) {
    marks[step] = String(step);
  }

  const handleChange = (val) => {
    callback(val);
  }

  // Create element for triangle arrow beneeth percentage box.
  if( percbox ) {
    if(percentagebox) {
      if(!tri) {
        const span = document.createElement("span");
        span.id = 'triangle';
        percentagebox.append(span);
        setBox({...box, triangle: true});
      }
    } else {
      if(document.getElementById('triangle')) {
        document.getElementById('triangle').remove();
      }
      if(tri) {
        setBox({...box, triangle: false});
      }
    }
  }
  
  // Initial value
  let points = [0];
  
  // Current value
  if(currentAnswer) {
    points = currentAnswer.answer;
  } else { // Initial answer
    handleChange([0]);
  }

  return (
    <>
      {options ? (
        <>
          <div className={'div-center w-full px-0 sm:px-0'} id="range">

            <Slider
              attrs={{class : 'r-range-slider horizontal'}}
              start={min}
              points={[points]}
              end={max}
              labelStep={10}
              scaleStep={5}
              onChange={handleChange}
              editValue={(value)=>value + '%'}
              scaleStyle={(value)=>{
                return {
                  width:6,
                  height:6,
                  top:30,
                  borderRadius:'100%',
                  background:'#888',
                  transform:'translateX(-3px)'
                }
              }}
              labelStyle={()=>{
                return {
                  top:46,
                  color:'#888'
                }
              }}
              lineStyle={()=>{
                return {
                  background:'#ddd'
                }
              }}
              pointStyle={()=>{
                return {
                  background:'#ccc',
                  border:'2px solid #888'
                }
              }}
            /> 

            <div className={"flex justify-between slider-scales mt-0 font-[500] pt-1 -ml-4 pl-4"}>
              <div className={'max-w-[40%] md:max-w-[40%] lg:max-w-[30%] text-size-13 lg:text-size-16'}>{min_label}</div>
              <div className={'max-w-[40%] md:max-w-[40%] lg:max-w-[30%] text-right text-size-13 lg:text-size-16'}>{max_label}</div>
            </div>
          </div>
        </>
      ):null}

    </>
  );
};

export default QuestionSlider;
